export const i18nChat = {
  title: 'Assistente',
  bot: 'Bot',
  user: 'Você:',
  send: 'Enviar',
  typing: 'Digitando...',
  close: 'Fechar',
  placeholder: 'Pergunte algo',
  beta: 'Beta',
  help_title: 'Como posso ajudá-lo?',
  chat_suggestions: {
    cases: 'Quais são meus casos abertos?',
    new_case: 'Como criar um caso?',
    asset: 'Mais detalhes sobre um equipamento especifico',
  },
  thinking: 'Pensando, aguarde um momento',
  messages: {
    error: 'Desculpe, ocorreu um erro. Por favor, tente novamente.',
    timeout:
      'Atualmente estou tendo dificuldades para concluir esta solicitação devido a limitações técnicas causadas pelo volume ou pela complexidade dos dados. Você pode obter melhores resultados se reformular sua pergunta de uma forma mais específica ou focada. Estou aqui para ajudar!',
  },
  chat_history: {
    title: 'Histórico de chats',
    today: 'Hoje',
    older: 'Últimos dias',
    start_new_chat: 'Iniciar novo chat',
    session: 'Sessão',
    delete_title: 'Tem certeza de que deseja excluir este chat?',
    delete_info:
      'Esta ação fará com que informações sejam perdidas. Tem certeza de que deseja continuar?',
    delete_cancel: 'Cancelar',
    delete_confirm: 'Sim, excluir',
  },
};
